import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock, Zap } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!loading && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center px-6 py-20" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <span className="inline-flex items-center justify-center w-11 h-11 border border-yellow-400/40 bg-yellow-400/5">
            <Zap className="w-6 h-6 text-yellow-400" strokeWidth={2.5} />
          </span>
          <div className="font-heading">
            <div className="text-white font-black text-xl uppercase tracking-tight leading-none">Vortex Ghost</div>
            <div className="text-[10px] tracking-[0.28em] text-zinc-500 font-mono uppercase mt-1">Operator Console</div>
          </div>
        </div>

        <div className="card-vg p-8">
          <div className="overline">Restricted Access</div>
          <h1 className="font-heading text-3xl font-bold mt-3 flex items-center gap-3">
            <Lock className="w-6 h-6 text-yellow-400" /> Admin Login
          </h1>
          <p className="text-zinc-500 text-sm mt-3">Authorized operators only.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <label className="overline mb-2 block !text-zinc-400">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-vg"
                placeholder="admin@vortexghost.com"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="overline mb-2 block !text-zinc-400">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-vg"
                required
                data-testid="login-password"
              />
            </div>

            {error && (
              <div className="text-red-400 text-sm border border-red-500/30 bg-red-500/5 p-3" data-testid="login-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={submitting} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="login-submit">
              {submitting ? <><Loader2 className="w-4 h-4 animate-spin" /> Authenticating…</> : "Authenticate"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
